export default __webpack_public_path__ + "47ef9813830062be07c918dcc2f748f6.svg";